<template>
    <div class="organize">
        <TitlePart text="Supporting Organizations"/>
        <a-row :gutter="[24,24]" class="myrow">
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/lsgi-logo.png" alt="">
                </div>
            </a-col>
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/HKUSTGZ.png" alt="">
                </div>
            </a-col>
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/UOG.png" alt="">
                </div>
            </a-col>
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/TAM.png" alt="">
                </div>
            </a-col>
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/ISUIBanner.png" alt="">
                </div>
            </a-col>
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/SCRI_Primary_logo_color_horizontal.png" alt="">
                </div>
            </a-col>
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/HKIS_logo.jpg" alt="">
                </div>
            </a-col>
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/HongKongGISAssociation.png" alt="">
                </div>
            </a-col>
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/LandsDepartmentBanner.jpg" alt="">
                </div>
            </a-col>
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/CASM.png" alt="">
                </div>
            </a-col>
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/CSGPC.png" alt="">
                </div>
            </a-col>
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/Rics-Logo.png" alt="">
                </div>
            </a-col>
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/hkabaeima.jpg" alt="">
                </div>
            </a-col>
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/buildingSMART-hk.jpg" alt="">
                </div>
            </a-col>
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/HKYSA_logo.png" alt="">
                </div>
            </a-col>
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/scc_logo.jpg" alt="">
                </div>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import TitlePart from '@/components/TitlePart/TitlePart.vue'
    export default {
        components:{
            TitlePart
        }
    }
</script>

<style lang="less" scoped>
    @import "./style.less" ;
</style>